import React, { useEffect, useState } from "react";
import {
  VIPSDataServiceURL,
  requestOptions,
} from "../../Constants/GlobalConstant";
import { createSearchParams, useLocation } from "react-router-dom";
import { saveSessionString } from "../../CommonFuntion/CheckSession";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
const SelectDivision = (post) => {
  const [dropdownData, setDropdownData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedValue, setSelectedValue] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");
  const [userId, setUserId] = useState(null);
  const [storeGrpDesc, setStoreGrpDesc] = useState(null);
  let location = useLocation();
  const searchParams = createSearchParams(location.search);

  useEffect(() => {
    const fetchData = async (userId2) => {
      try {
        const response = await fetch(
          `${VIPSDataServiceURL}` + `/User/GetUserDivisions?userId=${userId2}`,
          requestOptions
        );
        const result = await response.json();
        setDropdownData(result);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    if (typeof post.post !== "undefined" && post.post !== "") {
      let SessionArray = post.post.paxWebSessionStrings;
      let userId2 = "";
      SessionArray.forEach(function (item) {
        if (item.Key == "user_id") {
          setUserId(item.Value);
          userId2 = item.Value;
        }
        if (item.Key == "store_grp_desc") {
          setStoreGrpDesc(item.Value);
        }
        if (item.Key == "division_id") {
          setSelectedValue(item.Value);
        }
      });
      fetchData(userId2);
    }
  }, [post]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleUpdate = () => {
    const isValidValue = dropdownData.some(
      (item) => item.value === selectedValue
    );
    if (!selectedValue || !isValidValue) {
      setUpdateStatus("Please select a value.");
      return;
    }

    saveSessionString(userId, selectedValue, searchParams.get("session_id"))
      .then(() => {})
      .then(() => {
        var path =
          window.location.origin +
          "/" +
          process.env.REACT_APP_ORDERING_PATH +
          "?" +
          `${createSearchParams(
            location.search
          ).toString()}&SelectedDivision=${selectedValue}`;
        window.location.href = path;
      });
  };

  if (loading)
    return <div style={{ width: "100%", margin: "0 20px" }}>Loading...</div>;
  if (error)
    return (
      <div style={{ width: "100%", margin: "0 20px" }}>Error: {error}</div>
    );

  return (
    <Grid item id="content">
      <div style={{ width: "100%", margin: "0 20px" }}>
        <h5>Select Manufacturing Location For {storeGrpDesc} </h5>
        <select value={selectedValue} onChange={handleChange}>
          <option value="">Select an option</option>
          {dropdownData.length > 0 ? (
            dropdownData.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))
          ) : (
            <option>No data available</option>
          )}
        </select>

        <div>
          <Button
            variant="contained"
            className="clearbtn"
            onClick={handleUpdate}
          >
            Continue
          </Button>
        </div>

        {updateStatus && <p style={{ color: "red" }}>{updateStatus}</p>}
      </div>
    </Grid>
  );
};

export default SelectDivision;
